export default __webpack_public_path__ + "static/media/img_linear.94304c99.png";